import { render, staticRenderFns } from "./yaoqhygzjs_config.vue?vue&type=template&id=a89904ac&scoped=true&"
import script from "./yaoqhygzjs_config.vue?vue&type=script&lang=js&"
export * from "./yaoqhygzjs_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89904ac",
  null
  
)

export default component.exports